import React from 'react';
import './AddEventComponent.css';
import { GoPlus } from "react-icons/go";

const AddEventComponent = () => {
    return (
        <div className="banner_section" style={{ flex: "1" }}>
            <div className="container-events">
                <div className="upload_event_section">
                    <div className="row">
                        <div className="col-lg-12 mb_commn_pd_0">
                            <div className="row upload_festival_align">
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <h4 className="common_heading mb-0">Add Coupon Setting</h4>
                                </div>
                            </div>
                            <div className="Cus_shadow">
                                <div className="row">
                                    <div className="col-lg-4 col-sm-3 col-12">
                                        <div className="form-group">
                                            <label className="form-label">Coupon Amount</label>
                                            <input className="form-control" type="number" min="1" placeholder="10/-" />
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-sm-7 col-12">
                                        <div className="form-group">
                                            <label className="form-label">Minimum Purchase Amount For Default Gift Of SpecialOffer</label>
                                            <input className="form-control" type="number" min="1" placeholder="300/-" />
                                        </div>
                                    </div>
                                    <div className="col-lg-1 col-sm-2">
                                        <div className="form-group festi_section_save_btn">
                                            <button type="button" className="btn common_btn_pd view-data-btn">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="upload_event_section">
                    <div className="row">
                        <div className="col-lg-12 mb_commn_pd_0">
                            <div className="row upload_festival_align">
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <h4 className="common_heading mb-0">Slab Details</h4>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <button type="button" className="pull-right common_add_new_item_btn">
                                        <i className="bi bi-plus"></i> 
                                       <GoPlus/> Add Slab
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="table-responsive custom-table-01">
                                    <table className="table table-striped mb-0">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>For Position</th>
                                                <th>How Much Coupon For Slab</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td className="mb_position-width">1</td>
                                                <th className="mb_slab_coupon-width">15</th>
                                                <td className="festi_wdth_evnt_action">
                                                    <button className="common_btn btn-primary">Edit</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td className="mb_position-width">2</td>
                                                <th className="mb_slab_coupon-width">12</th>
                                                <td className="festi_wdth_evnt_action">
                                                    <button className="common_btn btn-primary">Edit</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td className="mb_position-width">3</td>
                                                <th className="mb_slab_coupon-width">10</th>
                                                <td className="festi_wdth_evnt_action">
                                                    <button className="common_btn btn-primary">Edit</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td className="mb_position-width">4</td>
                                                <th className="mb_slab_coupon-width">8</th>
                                                <td className="festi_wdth_evnt_action">
                                                    <button className="common_btn btn-primary">Edit</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td className="mb_position-width">5</td>
                                                <th className="mb_slab_coupon-width">6</th>
                                                <td className="festi_wdth_evnt_action">
                                                    <button className="common_btn btn-primary">Edit</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td className="mb_position-width">6</td>
                                                <th className="mb_slab_coupon-width">3</th>
                                                <td className="festi_wdth_evnt_action">
                                                    <button className="common_btn btn-primary">Edit</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="upload_event_section">
                    <div className="row">
                        <div className="col-lg-12 mb_commn_pd_0">
                            <div className="row upload_festival_align">
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <h4 className="common_heading mb-0">Event Details</h4>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <button type="button" className="pull-right common_add_new_item_btn">
                                        <i className="bi bi-plus"></i> <GoPlus/> Add New Event
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-sm-12">
                                    <div className="data_not-availble_box">
                                        <p className="mb-1">No Event Added Yet.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="upload_festi_banner_section">
                    <div className="row">
                        <div className="col-lg-12 mb_commn_pd_0">
                            <div className="row upload_festival_align">
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <h4 className="common_heading mb-0">Banner Details</h4>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <button type="button" className="pull-right common_add_new_item_btn">
                                        <i className="bi bi-plus"></i> <GoPlus/> Add New Banner
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-sm-12">
                                    <div className="data_not-availble_box">
                                        <p className="mb-1">No Banners Uploaded Yet.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="festi_product_section">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="common_heading">Add Products</h4>
                            <div className="Cus_shadow mb_upload_pd_spc">
                                <div className="row">
                                    <div className="col-lg-4 col-sm-4 col-12">
                                        <div className="form-group">
                                            <label className="required-label form-label">Product Name</label>
                                            <input id="productName" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-4 col-12">
                                        <div className="form-group">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <textarea id="description" className="form-control" rows="1"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-4 col-12">
                                        <div className="form-group">
                                            <label htmlFor="mrp" className="form-label">MRP</label>
                                            <input id="mrp" className="form-control" type="number" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-4 col-12">
                                        <div className="form-group">
                                            <label htmlFor="category" className="form-label">Select Banners 
                                            </label>
                                            <select id="category" className="form-control">
                                                <option value="1">Electronics</option>
                                                <option value="2">Clothing</option>
                                                <option value="3">Home Appliances</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-4 col-12">
                                        <div className="form-group">
                                            <label htmlFor="netPrice" className="form-label">Select Slab
                                            </label>
                                            <input id="netPrice" className="form-control" type="number" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-4 col-12">
                                        <div className="form-group">

                                            <label htmlFor="image" className="form-label">Product Image</label>
                                            <input id="image" className="form-control" type="file" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <button type="submit" className="btn common_btn_pd">Add Product</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="festi_product_listing">
                    <div className="row"><h5>Product Listing</h5>
                        <div className="col-md-12"><div className="table-responsive custom-table-01">
                            <table className="table table-striped table-hover">
                                <thead><tr><th>Product Name</th>
                                    <th>Image</th>
                                    <th>Description</th>
                                    <th>MRP</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Banner Id</th>
                                    <th>To Position</th>
                                    <th>Action</th></tr></thead>
                                <tbody><tr>
                                    <td className="mb_position-width">Harry potter chambers of secret</td>
                                    <td>
                                        <img src="https://edapi.elitewebdemo.com/Images/SpecialOfferProduct/de5414d3-5a32-405d-acdc-44ac0f8a9ef1/e78c4936-eb39-4152-b5a4-de2b80bb4f63.jpg" className="img-thumbnail" style={{ maxWidth: "150px" }} /></td>
                                    <td>Nice book</td>
                                    <td>599</td>
                                    <td><div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" /></div></td>
                                    <td>12/10/2024 12:11:24 PM</td>
                                    <td>cb66e198-6850-4c7a-a53a-a86411447704</td>
                                    <td>2</td>
                                    <td><button className="common_btn btn-primary">Edit</button></td></tr><tr><td className="mb_position-width">Hair brush</td>
                                        <td><img src="https://edapi.elitewebdemo.com/Images/SpecialOfferProduct/e76ab0d5-d86c-4956-9ecd-55933ca42ae4/dd846d4e-d2ac-4c1d-92cc-7586367a223c.jpg" className="img-thumbnail" style={{ maxWidth: "150px" }} /></td>
                                        <td>Hair brush for long hair</td>
                                        <td>399</td>
                                        <td><div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" /></div></td>
                                        <td>12/10/2024 12:08:47 PM</td>
                                        <td>cb66e198-6850-4c7a-a53a-a86411447704</td>
                                        <td>1</td>
                                        <td><button className="common_btn btn-primary">Edit</button></td></tr><tr><td className="mb_position-width">Harry Potter Soccers of stone </td>
                                        <td><img src="https://edapi.elitewebdemo.com/Images/SpecialOfferProduct/ace7b416-6369-4b2d-88f6-7927e670dddf/c761683a-ddaa-48d9-9679-9b9bcc8f8f7b.jpg" className="img-thumbnail" style={{ maxWidth: "150px" }} /></td>
                                        <td>Nice book</td>
                                        <td>599</td>
                                        <td><div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" /></div></td>
                                        <td>12/10/2024 12:10:21 PM</td>
                                        <td>cb66e198-6850-4c7a-a53a-a86411447704</td>
                                        <td>2</td>
                                        <td><button className="common_btn btn-primary">Edit</button></td></tr><tr><td className="mb_position-width">Water bottle</td>
                                        <td><img src="https://edapi.elitewebdemo.com/Images/SpecialOfferProduct/dda1a2fd-7690-4fb5-9135-8df5892e7c0d/ea84b740-b3af-4ee5-8026-8099c5dd3c86.jpg" className="img-thumbnail" style={{ maxWidth: "150px" }} /></td>
                                        <td>nice plastic water bottle</td>
                                        <td>299</td>
                                        <td><div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" /></div></td>
                                        <td>12/10/2024 12:13:00 PM</td>
                                        <td>cb66e198-6850-4c7a-a53a-a86411447704</td>
                                        <td>3</td>
                                        <td><button className="common_btn btn-primary">Edit</button></td></tr><tr><td className="mb_position-width">lunch box</td>
                                        <td><img src="https://edapi.elitewebdemo.com/Images/SpecialOfferProduct/024043ab-c898-4ae6-98d6-dc52ebb92c9c/814b8836-6fcc-45e8-9c19-27c518d86ed7.jpg" className="img-thumbnail" style={{ maxWidth: "150px" }} /></td>
                                        <td>lunch box</td>
                                        <td>299</td>
                                        <td><div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" /></div></td>
                                        <td>12/10/2024 12:13:43 PM</td>
                                        <td>cb66e198-6850-4c7a-a53a-a86411447704</td>
                                        <td>3</td>
                                        <td><button className="common_btn btn-primary">Edit</button>
                                        </td></tr><div className="col-lg-12 mb_commn_pd_0"><div className="pagination panination_number"><span>Page 1 of 2</span>
                                        <a className='panination_number_next'>
                                            Next
                                        </a></div>
                                    </div>
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="festi_product_listing"><div className="row"><h5>Winners Of Products Listing</h5>
                    <div className="form-group"><label for="eventSelect">Choose an event to view its winners</label>
                        <select id="eventSelect" className="form-control"><option value="">-- Select Event --</option>
                            <option value="050e9b82-7a8b-431a-b5b8-7a1e8925c3e0">testing 2024</option><option value="18dab6b1-c053-450a-b811-4d3e0fc6b980">Testing event2</option>
                            <option value="766bbdd5-a617-4778-9e39-74cc4805ecb1">Testing event</option><option value="447d008e-6243-4d0b-a940-fdf1f70a1d7a">Christmas eve</option>
                            <option value="905415b7-aa5e-4300-97d8-3a40a0e00780">New year 2025</option></select></div><div className="col-md-12"><div className="table-responsive custom-table-01">
                                <table className="table table-striped table-hover"><thead><tr><th>Image</th>
                                    <th>Description</th>
                                    <th>Position</th>
                                    <th>UserName</th>
                                    <th>Address</th>
                                    <th>Claimed?</th></tr></thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>
                </div>

                <div className="festi_product_listing">
                    <div className="row">
                        <h5>Event Summary</h5>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label for="eventSelect">Choose an event to view its summary</label>
                                <select id="eventSelect" className="form-control"><option value="">-- Select Event --</option>
                                    <option value="050e9b82-7a8b-431a-b5b8-7a1e8925c3e0">testing 2024</option><option value="18dab6b1-c053-450a-b811-4d3e0fc6b980">Testing event2</option>
                                    <option value="766bbdd5-a617-4778-9e39-74cc4805ecb1">Testing event</option><option value="447d008e-6243-4d0b-a940-fdf1f70a1d7a">Christmas eve</option>
                                    <option value="905415b7-aa5e-4300-97d8-3a40a0e00780">New year 2025</option></select></div><div className="table-responsive custom-table-01"><table className="table table-striped table-hover">
                                        <thead><tr><th>S.No</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Address</th>
                                            <th>Action</th></tr></thead>
                                        <tbody><tr><td>1</td><td>
                                            <img src="https://edapi.elitewebdemo.com/Images/UserProfile/414c0ce3-cd79-4fd1-8dd0-67ce8afecb6b/145fc523-1abb-421a-921e-acbdde376809.jpg" className="table_manager_role_img_wdth" style={{width:"100px"}} alt="Image" /></td><td>divyanshu sharma</td>
                                            <td>divyanshu.sharma6614@gmail.com</td>
                                            <td>Gurudwara, Sector 39C, mandir, Chandigarh, Chandigarh, 160036,7973694752</td>
                                            <td><button className="common_btn btn-primary">Show Summary</button></td></tr><tr><td>2</td><td>
                                                <img src="/image/unisexImage.jpeg" className="table_manager_role_img_wdth w-100" alt="Image" /></td><td>Yogesh Sharma</td>
                                                <td>yogesh@elitewebtechnologies.com</td>
                                                <td>Dgjxxc , Dhrxfb, , Rydgjj, Fjefg, 1225589,588982689</td>
                                                <td><button className="common_btn btn-primary">Show Summary</button></td></tr><tr><td>3</td><td>
                                                    <img src="/image/unisexImage.jpeg" className="table_manager_role_img_wdth w-100" alt="Image" /></td><td>Divyanshu Sharma</td>
                                                <td>divyanshu.cityinfomart@gmail.com</td>
                                                <td>shalimar, 34, , Chandigarh, Chandigarh, 160030,8585884554</td>
                                                <td><button className="common_btn btn-primary">Show Summary</button>
                                                </td>
                                            </tr></tbody>
                                    </table></div>
                        </div></div>
                </div>

            </div>
        </div>
    );
};
export default AddEventComponent;